<template>
  <div>
    <va-button @click="modalCategoryCreate=true">{{$t('categories.titleCreate')}}</va-button>
    <va-modal :okText="''" :cancelText="''" v-model="modalCategoryCreate">
      <form-category></form-category>
    </va-modal>
    <va-tree-root ref="treeView">
      <tree-category v-for="item in items" :node-item="item" :key="item.id" />
    </va-tree-root>
  </div>
</template>
<script>
import TreeCategory from './components/TreeCategory.vue'
import { mapGetters, mapActions } from 'vuex'
import FormCategory from './components/FormCategory.vue'

export default {
  data() {
    return {
      modalCategoryCreate: false,
      getQuery: {
        limit: 3,
        page: 1,
        level: 0,
      },
    }
  },
  components: {
    // ListCategories,
    TreeCategory,
    FormCategory,
  },
  computed: {
    ...mapGetters({
      loading: (state) => state.Categories?.isLoading,
      items: ['Categories/getCategories'],
    }),
  },
  methods: {
    ...mapActions('Categories', ['get', 'getItem']),
  },
  created() {
    this.get(this.getQuery)
  },
}
</script>
